import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../../../../shared/shared.module';
import { finalize, Subscription, tap } from 'rxjs';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { MatMenuModule } from '@angular/material/menu';
import { SIDENAV_CONFIG, SidenavItem } from '@edtech-ui/core/constants/module-config.constants';

@Component({
	selector: 'app-teacher-sidenavbar',
	standalone: true,
	imports: [MatTooltipModule, SharedModule, MatMenuModule],
	templateUrl: './teacher-sidenavbar.component.html',
	styleUrls: ['./teacher-sidenavbar.component.scss'],
})
export class TeacherSidenavbarComponent implements OnInit, OnDestroy {
	@Input() collapsed = false;
	@Output() toggle = new EventEmitter<void>();
	@Output() routeSelected = new EventEmitter<void>();
	subscription = new Subscription();
	allowedModules: string[] = [];
	menuItems: SidenavItem[] = [];

	constructor(
		private _toastr: ToastrService,
		private _authService: AuthServiceService,
		private router: Router,
	) {
	}

	ngOnInit(): void {
		this.subscription.add(
			this._authService.allowedModules$.subscribe(modules => {
				this.allowedModules = modules;
				this.filterMenuItems();
			})
		);
		this.subscription.add(
			this.router.events.subscribe((event) => {
				if (event instanceof NavigationEnd) {
					this.routeSelected.emit();
				}
			})
		);
	}

	filterMenuItems() {
		this.menuItems = this.processItems(SIDENAV_CONFIG);
	}

	processItems(items: SidenavItem[]): SidenavItem[] {
		const result: SidenavItem[] = [];

		for (const item of items) {
		//	const hasModule = this.allowedModules.includes(item.module);
			const isAuthorized = this._authService.isAuthorized(item);

			if (item.subItems && item.subItems.length > 0) {
				const validChildren = this.processItems(item.subItems);
				if (validChildren.length > 0) {
					result.push({ ...item, subItems: validChildren });
				}
			} else {
				// if (hasModule && isAuthorized) {
				// 	result.push(item);
				// }
				if (isAuthorized) {
    result.push(item);
}
			}
		}
		return result;
	}

	toggleSidenav() {
		this.toggle.emit();
	}
	expandedMenus: { [key: string]: boolean } = {};

	toggleSubmenu(item: SidenavItem): void {
		if (this.collapsed || !item.subItems) {
			return;
		}
		this.expandedMenus[item.label] = !this.expandedMenus[item.label];
	}

	isExpanded(item: SidenavItem): boolean {
		return this.expandedMenus[item.label] || false;
	}

	logout() {
		this._authService.logout(this.router).subscribe({
			next: (response) => {
				if (response.Success) {
					this._toastr.success('Logged out successfully.');
				} else {
					this._toastr.error(response.Message || 'Logout failed');
				}
			},
			error: () => {
				this._toastr.error('An error occurred during logout');
			}
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}